import { createContext, useContext } from "react";

export const SessionReadyContext = createContext(true);

export const useSessionReady = () => useContext(SessionReadyContext);
